import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { ActionListItem, IconButton, HorizontalStack } = designSystem;

function BlockHideOnControl({ title, items, onItemClick }) {
  return (
    <ActionListItem
      title={title}
      noninteractive
      contentBottom={
        <HorizontalStack gap="spacing-3-xs" verticalAlign="center">
          {items.map(({ target, glyph, label, isHidden }) => (
            <IconButton
              key={target}
              glyph={isHidden ? `${glyph}-off` : glyph}
              label={label}
              selected={isHidden}
              transparent
              size="extra-large"
              onClick={(event) => {
                event.stopPropagation();
                onItemClick(target);
              }}
            />
          ))}
        </HorizontalStack>
      }
    />
  );
}

BlockHideOnControl.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.string.isRequired,
      glyph: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isHidden: PropTypes.bool.isRequired,
    })
  ).isRequired,
  onItemClick: PropTypes.func.isRequired,
};

export default BlockHideOnControl;
